@if (region; as region) {
    <cll-dialog-layout>
        <cll-dialog-header>
            <cll-dialog-title>Edit general information</cll-dialog-title>
            <cll-dialog-subtitle>For {{ region.name }}</cll-dialog-subtitle>
        </cll-dialog-header>
        <div class="dialog-detail">
            <div class="dialog-container-header">
                <cll-icon type="outlined" [size]="24">person</cll-icon>
                <span class="dialog-container-header-text">Region details</span>
            </div>
            <div>
                <cll-form-field label="Region reference">
                    <input cllFormInput [formControl]="regionDetailsFormGroup.controls.reference" type="text">
                </cll-form-field>
            </div>
            <div>
                <cll-form-field label="Region name">
                    <input cllFormInput [formControl]="regionDetailsFormGroup.controls.name" type="text">
                </cll-form-field>
            </div>
        </div>
        <span class="dialog-divider"></span>
        @if (this.updateRegionRequest.loading()) {
            <cll-spinner />
        }

        @if (this.updateRegionRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }
        <cll-dialog-footer>
            <button cll-button colour="variant" cllDialogClose>
                Cancel
            </button>
            <button cll-filled-button colour="secondary" (click)="update()">
                Update
            </button>
        </cll-dialog-footer>
    </cll-dialog-layout>
}
